import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import {
  serversFetchAllFailureAction
, serversFetchAllRequestAction
, serversFetchAllSuccessAction
, serversFetchOneFailureAction
, serversFetchOneRequestAction
, serversFetchOneSuccessAction
, setSelectedServerName
} from './serversActions';
import { ServerModel } from '../../models/serverModel';
import { ServersStateModel } from './serversStateModel';

export const serversAdapter = createEntityAdapter<ServerModel>();

const initialState: ServersStateModel = serversAdapter.getInitialState({
  loading: false,
  errors: [],
});

export const serversReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setSelectedServerName, (state, action) => {
      state.selectedServerName = action.payload;
    })

    .addCase(serversFetchAllRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(serversFetchAllSuccessAction, (state, action) => {
      state.loading = false;
      serversAdapter.setMany(state, action.payload);
    })
    .addCase(serversFetchAllFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    })

    .addCase(serversFetchOneRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(serversFetchOneSuccessAction, (state, action) => {
      state.loading = false;
      serversAdapter.upsertOne(state, action.payload);
    })
    .addCase(serversFetchOneFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    });
});
